<template>
  <div class="teaching-arrange-setting">
    <div class="header">
      <div class="title">排课通用设置</div>
    </div>
    <div class="main">
      <div class="main-cont">
        <TeachingArrangeSettingMain></TeachingArrangeSettingMain>
      </div>
    </div>
  </div>
</template>

<script>
import TeachingArrangeSettingMain from './main'
export default {
  name: 'TeachingArrangeSetting',
  components: {
    TeachingArrangeSettingMain
  }
}
</script>

<style lang="scss">
  .teaching-arrange-setting {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      position: relative;
      & > .title {
        font-size: 13px;
        text-align: center;
        background-color: #fff;
        padding: 15px;
        border-bottom: 1px solid #ebeef5;
        box-sizing: border-box;
      }
    }
    & > .main {
      flex: auto;
      background-color: #fff;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>
